import * as React from 'react';
import { Node as UnbinaryNode, Ports as UnbinaryPorts, PortsContainer as UnbinaryPortsContainer, Title as UnbinaryTittle, TitleName as UnbinaryTittleName } from "../nodes/unbinary/UnBinaryNodeWidget";
import { Port as UnbinaryPort } from "../nodes/unbinary/UnBinaryPortLabelWidget";
import { Node as ConstantNode, Title as ConstantTitle, TitleName as ConstantTitleName } from "../nodes/constant/ConstantNodeWidget";
import { Node as QuaternaryNode } from "../nodes/quaternary/QuaternaryNodeWidget";
import { Node as TernaryNode } from "../nodes/ternary/TernaryNodeWidget";
import { ADDPORT } from "../nodes/ConstantNames";
import { NodeWidget as NodeWidgetForTernary } from "../nodes/ternary/TernaryNodeWidget";
import { NodeWidget as NodeWidgetForQuaternary } from "../nodes/quaternary/QuaternaryNodeWidget";
export const UnbinaryIcon = () => {
  return /*#__PURE__*/React.createElement(UnbinaryNode, {
    style: {
      pointerEvents: "none"
    }
  }, /*#__PURE__*/React.createElement(UnbinaryTittle, null, /*#__PURE__*/React.createElement(UnbinaryTittleName, null, "Node")), /*#__PURE__*/React.createElement(UnbinaryPorts, null, /*#__PURE__*/React.createElement(UnbinaryPortsContainer, null, /*#__PURE__*/React.createElement(UnbinaryPort, null, ADDPORT))));
};
export const ConstantIcon = () => {
  return /*#__PURE__*/React.createElement(ConstantNode, {
    style: {
      pointerEvents: "none"
    }
  }, /*#__PURE__*/React.createElement(ConstantTitle, null, /*#__PURE__*/React.createElement(ConstantTitleName, null, "Const")));
};
export const TernaryIcon = () => {
  let size = 50;
  return /*#__PURE__*/React.createElement(TernaryNode, {
    size: size
  }, /*#__PURE__*/React.createElement(NodeWidgetForTernary, {
    size: size,
    color: "rgb(255,255,0)",
    isSelected: false
  }));
};
export const QuaternaryIcon = () => {
  let size = 50;
  return /*#__PURE__*/React.createElement(QuaternaryNode, {
    size: 50
  }, /*#__PURE__*/React.createElement(NodeWidgetForQuaternary, {
    size: size,
    color: "rgb(255,255,0)",
    isSelected: false
  }));
};